import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import EditMessageModal from "../EditMessageModal";
import ForwardMessageModal from "../ForwardMessageModal";

import { AuthContext } from "../../context/Auth/AuthContext";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [editMessageOpen, setEditMessageOpen] = useState(false);
  const [forwardModalOpen, setForwardModalOpen] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenEditMessageModal = (e) => {
    setEditMessageOpen(true);
    handleClose();
  };

  const handleOpenForwardModal = () => {
    setForwardModalOpen(true);
    handleClose();
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <EditMessageModal
        open={editMessageOpen}
        onClose={() => setEditMessageOpen(false)}
        message={message}
      />
      <ForwardMessageModal
        open={forwardModalOpen}
        onClose={() => setForwardModalOpen(false)}
        message={message}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {((message.fromMe && !message.isDeleted) || user.profile === "admin") && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {message.isDeleted ? i18n.t("messageOptionsMenu.deleteForever") : i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && (
          <MenuItem onClick={handleOpenEditMessageModal}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        <MenuItem onClick={handleOpenForwardModal}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
      </Menu >
    </>
  );
};

export default MessageOptionsMenu;
